import React from "react";
import "./App.css";
import { Homepage } from "./containers/homepage";
import { Switch, Route } from "react-router-dom";
import PrivacyPolicy from "./containers/privacyPolicy";
import ThankYou from "./containers/ThankYou";
import TermsAndConditions from "./containers/TermsAndConditions";
import Products from "./containers/products/Products";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CartProvider } from "./subjects/CartContext";
import Checkout from "./containers/products/Checkout";
import Express from "./containers/express/Express";
import ExpressCheckout from "./containers/express/ExpressCheckout";
import FoodSafety from "./containers/FoodSafety";

// NOTE: branch resolution from the URL used to also happen here, via a
// fetch of /public/warehouse plus a case-sensitive
// `pathname.includes(branch.name)` check. That duplicated (and could
// conflict with) the slug-based matching Express.jsx already does properly
// against /express/:hub — removed so there's a single source of truth for
// "which branch is the customer on". Correct branch URLs are e.g.
// /express/nakuru (a route path segment), not /express?=nakuru.

const queryClient = new QueryClient();
function App(props) {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <CartProvider>
          <Switch>
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route exact path="/food-safety" component={FoodSafety} />
            <Route path="/thank-you" component={ThankYou} />
            <Route
              exact
              path="/terms-and-conditions"
              component={TermsAndConditions}
            />
            <Route exact path="/checkout" component={Checkout} />
            <Route exact path="/express-checkout" component={ExpressCheckout} />
            <Route exact path="/express/:hub?" component={Express} />
            <Route exact path={`/:branch/products`} component={Products} />
            <Route exact path="/" component={Homepage} />
          </Switch>
        </CartProvider>
      </QueryClientProvider>
      <ToastContainer position="top-center" />
    </>
  );
}

export default App;
